import reducer from "../reducerGenerator";

import * as actionTypes from "./actionTypes";
import * as reducerActions from "./reducerActions";

const initialState = {
  loading: false,
  error: false,
  success: false,
};

const mapper = {
  [actionTypes.SHOW_CONTACT_LOADER]: reducerActions.showLoader,
  [actionTypes.HIDE_CONTACT_LOADER]: reducerActions.hideLoader,
  [actionTypes.CONTACT_SENT]: reducerActions.contactSent,
  [actionTypes.CONTACT_SEND_FAILED]: reducerActions.contactSendFailed,
};

export default reducer(mapper, initialState);



// WEBPACK FOOTER //
// ./src/store/contacts/reducer.js